var _path, _path2, _path3, _circle, _path4, _circle2, _circle3, _path5, _circle4, _path6, _circle5, _circle6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 397,
    viewBox: "0 0 357 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 387.5C105 407.5 181.5 393.5 211 358.5C277 291 287.5 359.5 337 288.5C382.71 222.936 336.208 145.21 319 130.5C288 104 330.572 90.2189 300.5 47.4999C247 -28.5 120 1.99975 109.5 42.9999C100.513 78.0924 67.9999 67 26.9999 98.5C-14.0001 130 -3.49998 213.5 27 257.5C57.5 301.5 -0.534859 351.955 67 387.5Z",
    fill: "#28BC7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.148 214.308L137 264L187.37 225.433L227 175L175.148 214.308Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.917 215.617L157 194L178.667 222.543L207 245L184.917 215.617Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 219.5,
    r: 82.5,
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254 219.5C254 259.553 221.752 292 182 292C142.248 292 110 259.553 110 219.5C110 179.447 142.248 147 182 147C221.752 147 254 179.447 254 219.5Z",
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 97.5,
    r: 23.5,
    stroke: "white",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 97.5,
    r: 31.5,
    stroke: "white",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170 137V117C170 112.582 173.582 109 178 109H184C188.418 109 192 112.582 192 117V137",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 278,
    r: 5,
    stroke: "white",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187 160.5C187 162.848 184.904 165 182 165C179.096 165 177 162.848 177 160.5C177 158.152 179.096 156 182 156C184.904 156 187 158.152 187 160.5Z",
    stroke: "white",
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.5,
    cy: 218.5,
    r: 4.5,
    stroke: "white",
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 218.5,
    r: 4.5,
    stroke: "white",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.756 32V14.216H176.42L186.836 27.824V14.216H189.524V32H186.932L176.492 18.44V32H173.756Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.216 342.36L177.928 342.456L177.952 342.72C178 343.104 178.088 343.48 178.216 343.848C178.344 344.216 178.528 344.552 178.768 344.856C179.008 345.144 179.32 345.384 179.704 345.576C180.088 345.752 180.552 345.84 181.096 345.84C181.624 345.84 182.08 345.76 182.464 345.6C182.864 345.424 183.184 345.2 183.424 344.928C183.68 344.656 183.872 344.344 184 343.992C184.128 343.64 184.192 343.28 184.192 342.912C184.192 342.176 184.008 341.616 183.64 341.232C183.288 340.832 182.792 340.512 182.152 340.272C181.928 340.192 181.712 340.12 181.504 340.056C181.296 339.992 181.088 339.928 180.88 339.864C180.576 339.768 180.272 339.68 179.968 339.6C179.68 339.52 179.4 339.416 179.128 339.288C177.912 338.776 177.064 338.16 176.584 337.44C176.12 336.72 175.888 335.896 175.888 334.968C175.888 334.424 176 333.856 176.224 333.264C176.448 332.672 176.792 332.128 177.256 331.632C177.736 331.136 178.328 330.728 179.032 330.408C179.736 330.088 180.568 329.928 181.528 329.928C182.488 329.928 183.304 330.088 183.976 330.408C184.664 330.728 185.216 331.136 185.632 331.632C186.048 332.128 186.352 332.672 186.544 333.264C186.736 333.84 186.832 334.384 186.832 334.896V335.448L186.376 335.424C185.736 335.376 185.096 335.352 184.456 335.352H184.048L184.024 335.064C184.008 334.728 183.944 334.4 183.832 334.08C183.72 333.76 183.552 333.48 183.328 333.24C183.12 332.984 182.848 332.776 182.512 332.616C182.192 332.456 181.8 332.376 181.336 332.376C180.904 332.376 180.528 332.456 180.208 332.616C179.904 332.776 179.648 332.984 179.44 333.24C179.248 333.48 179.096 333.76 178.984 334.08C178.888 334.384 178.84 334.696 178.84 335.016C178.84 335.384 178.904 335.696 179.032 335.952C179.16 336.208 179.344 336.432 179.584 336.624C179.84 336.8 180.152 336.96 180.52 337.104C180.904 337.248 181.336 337.384 181.816 337.512C182.76 337.768 183.56 338.064 184.216 338.4C184.888 338.72 185.432 339.104 185.848 339.552C186.264 339.984 186.568 340.48 186.76 341.04C186.968 341.6 187.072 342.232 187.072 342.936C187.072 343.512 186.96 344.12 186.736 344.76C186.512 345.384 186.16 345.96 185.68 346.488C185.2 347.016 184.584 347.456 183.832 347.808C183.08 348.144 182.176 348.312 181.12 348.312C180.08 348.312 179.184 348.136 178.432 347.784C177.696 347.416 177.088 346.96 176.608 346.416C176.128 345.872 175.776 345.28 175.552 344.64C175.328 344 175.216 343.4 175.216 342.84V342.36Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.677 173.264H41.605L48.085 188.432L50.461 182.84L47.677 176.264H50.605L51.973 179.336L53.269 176.264H56.173L53.389 182.792L55.765 188.432L62.221 173.264H65.173L57.637 191H53.917L51.925 186.296L49.909 191H46.261L38.677 173.264Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M311.993 173.216H323.897L323.369 175.496H314.729V180.944H322.241V183.2H314.729V188.744H323.369L323.897 191H311.993V173.216Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.7648c613a52b35d40adc3a6d06b081a0.svg";
export { ForwardRef as ReactComponent };